module.exports = __webpack_public_path__ + "img/bgtop.fb300f34.jpg";